"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Platforms;
(function (Platforms) {
  Platforms["REACT_NATIVE"] = "REACT_NATIVE";
  Platforms["BROWSER"] = "BROWSER";
  Platforms["NODE"] = "NODE";
})(Platforms || (Platforms = {}));
var platformName = Platforms.NODE;
exports.platformName = platformName;
if (typeof document != 'undefined') {
  exports.platformName = platformName = Platforms.BROWSER;
} else if (typeof navigator != 'undefined' && navigator.product == 'ReactNative') {
  exports.platformName = platformName = Platforms.REACT_NATIVE;
}
var isReactNative = platformName == Platforms.REACT_NATIVE;
exports.isReactNative = isReactNative;
var isBrowser = platformName == Platforms.BROWSER;
exports.isBrowser = isBrowser;
var isNode = platformName == Platforms.NODE;
exports.isNode = isNode;